(function() {
  'use strict';
  angular.module('common')
  .service('taxIdBlockService',function() {
    var taxIdRules = [];
    var supportStrings = {
        IL1: "Unable to Access this member's information at this time please contact Customer Service at 800-367-6401.",
        TX1: "Unable to Access this member's information at this time please contact Customer Service at 877-442-4207.",
        NM1: "Unable to Access this member's information at this time please contact Customer Service at 888-454-5589.",    
        OK1:"Unable to Access this member's information at this time please contact Customer Service at 888-381-9727.",
        MT1: "Unable to Access this member's information at this time please contact Customer Service at 866-739-4090.",
        DN1: "Unable to Access this member's information at this time please contact Customer Service at 800-721-7987."
    }
    return {
      taxIdRules,
      filterMembers: function(members) {
        var returnMembers = [];
        _.each(members,(member,index) => {
          var memberValid = true;
          _.each(this.taxIdRules, (taxIdRule, index) =>{
            if(member.corpCode == taxIdRule.state) {
              memberValid = false;
            }
          });
          if(memberValid) {
            returnMembers.push(member);
          } else {
            returnMembers.push({invalidMember:true, supportString: supportStrings[member.corpCode]});
          }
        });
        return returnMembers;
      }
    };
  });
})();